import React from 'react';

import './InputSwitcher.css';

interface InputSwitcherProps {
  value: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
}

class InputSwitcher extends React.PureComponent<InputSwitcherProps> {
  public static ON_LABEL = 'On';

  public static OFF_LABEL = 'Off';

  render(): React.ReactElement {
    const {
      value,
      onChange,
      label,
    } = this.props;

    const switcherText = value ? InputSwitcher.ON_LABEL : InputSwitcher.OFF_LABEL;

    return (
      <div className="input-switcher">
        <div className="input-switcher-label">
          {label}
        </div>
        <div className="input-switcher-control">
          <label className="switch">
            <input
              type="checkbox"
              checked={value}
              onChange={onChange}
            />
            <span className="slider">{switcherText}</span>
          </label>
        </div>
      </div>
    );
  }
}

export default InputSwitcher;
